import React, { useState } from "react";
import styles from "../components/laymanComp_css/LaymanPage7.module.css";
import { Link } from "@mui/material";
import MembershipModal from "../../../components/Modal/MembershipModal"
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/stringTheory.json";

export default function LaymanPage7() {

  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };

  return (
    <>
    <Common_html BlockData={BlockData} />
    </>
  );
}
